import { CountUp } from 'countup.js';

const countup = document.querySelectorAll('.countup-number');
for( var i=0; i< countup.length; i++ ) {
    countup[i].setAttribute('id', 'countup-number-' + i);
    const thisCountUp = document.getElementById('countup-number-' + i);
    const number = thisCountUp.innerText 
    const countUp = new CountUp(thisCountUp, number, { enableScrollSpy: true, scrollSpyOnce: true });
}